<form [formGroup]="formGroup">
  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <div><pdq-heading element="h5">Token for Shopify</pdq-heading></div>
      <pdq-divider></pdq-divider>
      <div>
        <pdq-link
          label="View detailed installation instructions"
          [external]="true"
          [url]="'https://support.prettydamnquick.com/en/articles/8560867-adding-multiple-pdq-components'"></pdq-link>
        <pdq-input
          [disabled]="true"
          [formControl]="formGroup.get('usageToken')"
          label="Copy & paste this into Shopify's Components by 'Shipping rates filter token'"
          [clipboard]="true"></pdq-input>
        <pdq-extension-preview-token [usageTokenControl]="formGroup.get('usageToken')"></pdq-extension-preview-token>
      </div>
    </div>
  </pdq-card>
  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <div><pdq-heading element="h5">Settings</pdq-heading></div>
      <pdq-divider></pdq-divider>
      <div>
        <pdq-input
          label="Internal name"
          [formControl]="formGroup.get('title')"
          [invalid]="formGroup.get('title')?.errors?.required"
          invalidMsg="Internal name is required"></pdq-input>
        <pdq-input
          label="Internal description"
          [formControl]="formGroup.get('internalName')"
          placeholder="Description..."></pdq-input>
      </div>
    </div>
  </pdq-card>
  <pdq-card variant="popover" color="white"
    ><div class="card-content">
      <div><pdq-heading element="h5">Display rules</pdq-heading></div>
      <pdq-divider></pdq-divider>
      <div>
        <p>The extension will be hidden if selecting the checkbox leaves no available shipping methods.</p>
        <pdq-rules-dynamic-form
          [formGroup]="formGroup"
          formArrayFieldName="restrictionsRules"
          [rules]="restrictionsRules | addCurrencyOption: shopCurrencySymbol"
          [entities]="entities"
          [shopCurrencySymbol]="shopCurrencySymbol"
          [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
      </div></div
  ></pdq-card>
  <pdq-card variant="popover" color="white"
    ><div class="card-content" formGroupName="config">
      <div><pdq-heading element="h5">Configure</pdq-heading></div>
      <pdq-divider></pdq-divider>
      <div>
        <pdq-input
          [invalid]="formGroup.get('config.checkboxText')?.errors?.required"
          invalidMsg="Checkbox text is required"
          placeholder="Checkbox text i.e. show only insured shipping options..."
          [formControl]="formGroup.get('config.checkboxText')"
          label="Checkbox text"></pdq-input>
        <pdq-textarea [control]="formGroup.get('config.checkboxHelpText')" label="Help text"></pdq-textarea>
        <pdq-divider variant="dashed"></pdq-divider>
        <pdq-heading element="h6">Checking the widget box will show:</pdq-heading>
        <ng-container formGroupName="filter">
          <pdq-radio-group formControlName="type">
            <pdq-radio-button
              [value]="FilterType.SUB_TEXT"
              [checked]="formGroup.get('config.filter.type').value === FilterType.SUB_TEXT"
              text="Only shipping methods that contain this specific text"></pdq-radio-button>
            <pdq-radio-button
              [value]="FilterType.METHOD_LIST"
              [checked]="formGroup.get('config.filter.type').value === FilterType.METHOD_LIST"
              text="Only these selected shipping methods"></pdq-radio-button>
          </pdq-radio-group>
          @if (formGroup.get('config.filter.type').value === FilterType.SUB_TEXT) {
            <pdq-input
              invalidMsg="Specific text is required"
              [invalid]="formGroup.get('config.filter.subText').errors?.required"
              [formControl]="formGroup.get('config.filter.subText')"
              placeholder="Specific text"
              label=""></pdq-input>
          } @else {
            <div class="autocomplete">
              <linked-methods-autocomplete
                [control]="formGroup.get('config.filter.methodNames')"
                [options]="
                  loadedShippingMethods$ | async | autocompleteShippingMethodsNames
                "></linked-methods-autocomplete>
              <p>{{ checkoutGroupComment }}</p>
              @if (formGroup.get('config.filter.methodNames').errors?.required) {
                <p>*At least one method required</p>
              }
            </div>
          }</ng-container
        ><pdq-divider variant="dashed"></pdq-divider>
        <pdq-heading element="h6">Unchecking the widget box will show:</pdq-heading>
        <pdq-radio-group formControlName="uncheckedBehavior">
          <pdq-radio-button
            [value]="UncheckedBehavior.EXCLUDE_CONFIGURED_METHODS"
            [checked]="formGroup.get('config.uncheckedBehavior').value === UncheckedBehavior.EXCLUDE_CONFIGURED_METHODS"
            text="All available shipping methods, except the ones configured above"></pdq-radio-button>
          <pdq-radio-button
            [value]="UncheckedBehavior.SHOW_ALL_METHODS"
            [checked]="formGroup.get('config.uncheckedBehavior').value === UncheckedBehavior.SHOW_ALL_METHODS"
            text="All available shipping methods"></pdq-radio-button>
        </pdq-radio-group>
        <pdq-divider variant="dashed"></pdq-divider>
        <pdq-heading element="h6">Always show:</pdq-heading>
        <div class="bypass-options" formGroupName="bypassOptions">
          <pdq-checkbox
            formControlName="enableFreeMethodBypass"
            labelSize="small"
            label="Always show free shipping methods"></pdq-checkbox>
          <pdq-checkbox
            formControlName="enableSpecificMethodBypass"
            labelSize="small"
            label="Always show these selected methods"></pdq-checkbox>
          <div class="autocomplete" style="padding-left: 32px">
            <linked-methods-autocomplete
              [disabled]="!formGroup.get('config.bypassOptions.enableSpecificMethodBypass').value"
              [control]="formGroup.get('config.bypassOptions.bypassedMethodNames')"
              [options]="
                loadedShippingMethods$ | async | autocompleteShippingMethodsNames
              "></linked-methods-autocomplete>
            <p>{{ checkoutGroupComment }}</p>
            @if (formGroup.get('config.bypassOptions.bypassedMethodNames').errors?.required) {
              <p>*At least one method required</p>
            }
          </div>
        </div>
        <pdq-divider variant="dashed"></pdq-divider>
        <pdq-radio-group formControlName="defaultCheckboxState" label="Default state of the widget box">
          <pdq-radio-button
            [checked]="!!formGroup.get('config.defaultCheckboxState').value"
            text="Checked"
            [value]="true"></pdq-radio-button>
          <pdq-radio-button
            [checked]="!formGroup.get('config.defaultCheckboxState').value"
            text="Unchecked"
            [value]="false"></pdq-radio-button>
        </pdq-radio-group>
      </div>
    </div>
  </pdq-card>
</form>
